<div class="d-block modal-header">
  <div class="row pe-2 justify-content-between">
    <div class="col modal-title" id="modal-title">
      <span class="m-0 p-0 h4">Close Rental Agreement</span>
      @if (item) {
        <button
          class="px-1 py-0 m-0 btn fs-4 text-500 font-monospace align-baseline"
          [appCopyToClipboard]="item.number"
          title="Copy RA number">
          #{{ item.number }}
        </button>
      }
    </div>
    <button type="button" class="col-auto m-0 btn-close bg-secondary" aria-label="Close" (click)="dismiss()"></button>
  </div>
</div>
@if (vm$ | async; as vm) {
  <div class="d-flex flex-column p-3 pt-1 modal-body">
    <form [formGroup]="paymentForm" (submit)="submit()" id="6f778f15-e2ae-4d27-8d54-55905a470585">
      <div class="d-flex flex-fill flex-column px-0">
        <div class="row g-1 m-0">
          <div class="col-12">
            <div class="fw-semibold small">
              <span>Location</span>
            </div>
            <div class="col-12">
              <div class="row g-1 px-2 pb-2 m-0 bg-light rounded border">
                <div class="col-12">
                  <div class="text-muted small"><i class="text-primary fa fa-location-dot fa-fw"></i>Return</div>
                </div>
                <div class="col-8">
                  <p-iftalabel>
                    <p-autocomplete
                      appLocationAutocomplete
                      [group]="true"
                      optionLabel="selectedLabel"
                      [(ngModel)]="dropOffLocation"
                      [ngModelOptions]="{ standalone: true }"
                      [forceSelection]="true"
                      [showClear]="true"
                      inputId="dropOffLocationUid"
                      disabled>
                      <ng-template let-location pTemplate="item">
                        <div class="ps-2 fw-normal" [innerHTML]="location.optionLabel"></div>
                      </ng-template>
                      <ng-template let-group #group>
                        <div>
                          <span class="flag-icon" [class]="group.flagIcon"></span>
                          <span class="ms-2" [innerHTML]="group.countryName"></span>
                        </div>
                      </ng-template>
                    </p-autocomplete>
                    <label for="dropOffLocationUid">Location</label>
                  </p-iftalabel>
                </div>
                <div class="col-4">
                  <p-iftalabel>
                    <p-datepicker
                      [(ngModel)]="dateIn"
                      [ngModelOptions]="{ standalone: true }"
                      inputId="dateIn"
                      showIcon
                      [showTime]="true"
                      iconDisplay="input"
                      appendTo="body"
                      dateFormat="dd/mm/yy"
                      disabled />
                    <label for="dateIn">Date</label>
                  </p-iftalabel>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-6 col-xxl-4">
            <div class="fw-semibold small">
              <span>Period</span>
            </div>
            <div class="form-floating">
              <input
                type="number"
                class="form-control validated"
                id="numberOfDays"
                [value]="item?.numberOfDays"
                [disabled]="true" />
              <label for="numberOfDays">Days</label>
            </div>
          </div>
        </div>
        <div class="mt-1 fw-semibold small">
          <span>Values</span>
        </div>
        <div style="min-height: 300px" class="d-flex flex-fill">
          <ag-grid-angular
            class="flex-fill ag-theme-balham ag-rounded"
            [columnDefs]="columnDefs"
            [autoSizeStrategy]="{ type: 'fitGridWidth' }"
            [scrollLeft]="false"
            [pagination]="true"
            [paginationPageSizeSelector]="false"
            (gridReady)="valuesGridReady($event)" />
        </div>
        <div class="row g-1 mt-1 align-items-stretch">
          <div class="col-12 col-md-6 d-flex flex-column">
            <div class="fw-semibold small">
              <span>Documents/Totals</span>
            </div>
            <div style="min-height: 150px" class="d-flex flex-fill">
              <ag-grid-angular
                class="flex-fill ag-theme-balham ag-rounded"
                [columnDefs]="docColumnDefs"
                [autoSizeStrategy]="{ type: 'fitGridWidth' }"
                [scrollLeft]="false"
                [pagination]="false"
                [paginationPageSizeSelector]="false"
                (gridReady)="docGridReady($event)" />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="fw-semibold small">
              <span>Total Values</span>
            </div>
            <div class="row g-1">
              <div class="col-12">
                <div class="form-floating">
                  <input
                    type="number"
                    class="form-control validated"
                    id="totalValue"
                    [value]="item?.totalValueWithTax | number: '1.2-2'"
                    [disabled]="true" />
                  <label for="totalValue">Total Value</label>
                </div>
              </div>
              <hr class="col-12 mb-0 border" />
              <div class="col-12">
                <div class="form-floating">
                  <input
                    type="number"
                    class="form-control validated"
                    id="totalCashier"
                    [value]="item?.totalCashierWithTax | number: '1.2-2'"
                    [disabled]="true" />
                  <label for="totalCashier">Total in invoice (cashier)</label>
                </div>
              </div>
              <div class="col-12">
                <div class="form-floating">
                  <input type="number" class="form-control validated" id="totalPaid" formControlName="totalPaid" />
                  <label for="totalPaid">Total paid (cashier)</label>
                </div>
              </div>
              <div class="col-12">
                <div class="form-floating">
                  <input
                    type="number"
                    class="form-control fw-bolder text-success validated"
                    id="balance"
                    formControlName="balance" />
                  <label for="balance">Balance</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-end">
    <div class="row gap-1 m-0 justify-content-end">
      <button
        type="submit"
        form="6f778f15-e2ae-4d27-8d54-55905a470585"
        class="col-auto btn btn-success"
        [disabled]="loading || paymentForm.invalid">
        <div class="d-flex gap-2 justify-content-center align-items-center">
          @if (loading) {
            <div>
              <i class="fa-solid fa-circle-notch fa-spin fa-fw"></i>
            </div>
          } @else {
            <div>
              <i class="fa-solid fa-check fa-fw"></i>
            </div>
          }
          <div>Confirm</div>
        </div>
      </button>
      <button type="button" class="col-auto btn btn-outline-secondary" (click)="dismiss()">Cancel</button>
    </div>
  </div>
} @else {
  <div class="modal-body">
    <app-loader />
  </div>
}
